import { AppActions } from 'app/appSlice'
import { useEffect, useMemo } from 'react'
import { useDispatch } from 'react-redux'

const useTitles = (callback, dependencies = []) => {
    const dispatch = useDispatch()

    const titleMemoize = useMemo(callback, dependencies)

    useEffect(() => {
        dispatch(AppActions.titles(titleMemoize))
    }, dependencies)
}

export default useTitles